import {mapMutations, mapActions} from "ui.vue3.vuex";

export const Select = {
    data() {
        return {
            option: ''
        }
    },
    props:
        {
            element: {default: []}
        },
    created()
    {
        this.$Bitrix.eventEmitter.subscribe('apkpro:select:clearOption', this.clearOption);
    },
    beforeDestroy()
    {
        this.$Bitrix.eventEmitter.unsubscribe('apkpro:select:clearOption', this.clearOption);
    },
    methods: {
        ...mapMutations('filtersStore', ['setElement']),
        ...mapActions('filtersStore', ['sendFilters']),
        selectOption() {
            this.setElement({name: this.element['name'], value: this.option});
            this.sendFilters();
        },
        getLabel(option) {
            if(!!option.label) {
                return option.label;
            } else {
                return option.name;
            }
        },
        clearOption() {
            console.log('apkpro:select:clearOption');
            this.option = '';
            console.log(this.option)
            if(this.element.name !== 'education_grade') {
                let select = document.querySelector(`[name="${this.element.name}"]`);
                select.value = '';
                const select2 = new TsSelect2(select, {minimumResultsForSearch: Infinity, width: `250px`});
            }
        }
    },
    mounted() {
        if(this.element.name !== 'education_grade') {
            let select = document.querySelector(`[name="${this.element.name}"]`);
            const select2 = new TsSelect2(select, {minimumResultsForSearch: Infinity, width: `250px`});
        }
    },
    template: `
          <label class="input methodological-filters__option">
            {{element.label}}
            <select :multiple="element['multiple']" :name="element['name']" class="select input__field input__field-lt" @change="selectOption" v-model="option">
<!--              <option :value="" disabled selected>{{element.label}}</option>-->
              <option v-for="option in element.options" :key="option.id" :value="option.id">
                {{ getLabel(option) }}
              </option>
            </select>
          </label>
    `
}